module.exports = __webpack_public_path__ + "static/uxpin_notepad_6-3933f1764d68b4aeb7ebd9abfd5ae00e.png";